import { useIntl } from 'react-intl'
import {useListView} from '../core/ListViewProvider'

const FacilityEditModalHeader = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
const intl=useIntl()
  return (
    <div className='modal-header border-0 pt-6 px-8 pb-2'>
      {/* begin::Modal title */}
      <h2 className='fs-3 fw-bold text-gray-900 mb-0'>
        {itemIdForUpdate ? intl.formatMessage({id:'COMMON.UPDATE_FACILITY'}) : intl.formatMessage({id:'COMMON.ADD_FACILITY'})}
      </h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <button
        type='button'
        className='btn btn-sm btn-icon btn-active-color-primary'
        data-kt-ufacilities-modal-action='close'
        onClick={() => setItemIdForUpdate(undefined)}
      >
        <i className='bi bi-x-lg fs-3' />
      </button>
      {/* end::Close */}
    </div>
  )
}

export {FacilityEditModalHeader}
